export const handleCopy = (elem: HTMLElement) => {
  const copyText = elem?.textContent;
  if (typeof copyText === 'string') navigator.clipboard.writeText(copyText);
};
